<div fxFlex fxLayout="column" fxLayoutAlign="center center">
  <p>
    <mat-icon class="medium">info</mat-icon>
  </p>
  <p class="align-center">
    {{ messageKey | translate }}
  </p>
</div>
